import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InvoiceBulk from '../components/Invoice/InvoiceBulk';
import * as InvoiceVendorAction from '../actions/invoiceVendorAction';
import * as SnackBarAction from '../actions/snackbarAction';

function mapStateToProps(state) {
  return {
    ...state.Invoice,
    userInfo: { ...state.Chargecard?.userInfo },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...InvoiceVendorAction,
      ...SnackBarAction
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceBulk);
